import '@webcomponents/webcomponentsjs';

const isIE = () => {
    const ua = window.navigator.userAgent;
    return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
};

const polyfillWebComponents = async () => {
    if (isIE()) {
        await import('@webcomponents/shadycss/entrypoints/custom-style-interface');
        await import('@zywave/zui-custom-style');
    }
};

export { polyfillWebComponents };
